import React from "react";
import { connect } from 'react-redux';
import { useForm } from "react-hook-form";
import {handleInputChange,updateCoachStream} from '../../../redux/profile/profile.actions';

const Coachform = ({
  updateCoachStream
}) => {
  const {
    register,
    handleSubmit,
    watch,
    errors,
    getValues,
    trigger,
  } = useForm();

  const onSubmit = (data) => {
      updateCoachStream(data);
  };

  return (
     <div className="row">
          <div className="col-xs-12 col-md-12 col-sm-12 col-lg-12">
    <form id="coachStream" onSubmit={handleSubmit(onSubmit)}>
    <ol><li>
   <label htmlFor="fullName">Which of the following best describes you?*</label>
      <select name="user_background" className="form-control" ref={register({required: true})}>
        <option value="Working Professional (Self-Employed or Private or Government)">Working Professional (Self-Employed or Private or Government)</option>
        <option value="Job Seeker">Job Seeker</option>
        <option value="Competitive Exam Aspirant">Competitive Exam Aspirant</option>
        <option value="Student (High School, College, or University)">Student (High School, College, or University)</option>
        <option value="Teacher/Trainer">Teacher/Trainer</option>
        <option value="Retired">Retired</option>
        <option value="Homemaker">Homemaker</option>
        <option value="Others">Others</option>
      </select>
      </li>
      <li>
      <label htmlFor="fullName">Please choose the option that's most appropriate for you: You wish to improve your English to*</label>
      <select name="user_role" className="form-control" ref={register({required: true})}>
        <option value="0">Perform better at current/future workplace</option>
        <option value="1">Ace a Competitive Exam</option>
        <option value="2">Do well in School/College/University</option>
        <option value="3">Teach/Train better</option>
        <option value="4">Communicate better, in general</option>
      </select>
      </li>
      <li>
      <label htmlFor="fullName">You want the course to focus on*</label>
      <select name="user_skill" className="form-control" ref={register({required: true})}>
        <option value="0">Speaking Skills</option>
        <option value="1">Writing Skills</option>
        <option value="2">Both Speaking and Writing Skills</option>
      </select>
      </li></ol>
      <p className="btn-custom-karthik">
     <button aria-label="save" type="submit" className="btn btn-lg btn-success col-4">
                  START LEARNING
                </button></p>
      </form>
      </div></div>
    
  );
};

  const mapDispatchToProps = (dispatch) => {
  return {
    updateCoachStream: (obj) => dispatch(updateCoachStream(obj)),
  };
};

export default connect(null, mapDispatchToProps)(Coachform);